import React from "react";
import CustomSection from "../components/CustomSection";
import BackButton from "../components/BackButton";

const Privacity = () => {
  return (
    <CustomSection type="white">
      <BackButton />
      <div className="m-6 has-text-justified">
        <h1>Aviso de privacidad</h1>
        <br />
        <p>
          Este Aviso de Privacidad (en lo sucesivo el "Aviso de Privacidad")
          entrará en vigor desde su aceptación para los nuevos usuarios y está
          vigente desde Enero de 2019.
        </p>
        <p>
          La privacidad de la información de los usuarios es muy importante para
          DX INTERMEDIACION INDEPENDIENTE. Es por esa razón que se toman las
          precauciones y recaudos para resguardar su información, utilizando los
          mecanismos de seguridad informática de protección de la información
          más completos y eficaces. Como parte normal de nuestra actividad
          recogemos y, en algunos casos, revelamos información sobre nuestros
          usuarios y visitantes de nuestro sitio Web. Este Aviso de Privacidad
          describe la información que Dinerito Extra S.A. de C.V. , con
          domicilio en Rinconada de Almería 1485 Las Alamedas, Zapopan, Jalisco,
          México. (referida como "DX INTERMEDIACION INDEPENDIENTE") recoge sobre
          los usuarios y visitantes de la plataforma de comercio electrónico y
          del sistema de pagos online. Este Aviso de Privacidad, asimismo,
          describe qué puede hacerse con dicha información. Este aviso es muy
          detallado porque es importante que todos los usuarios y visitantes de
          nuestro sitio Web conozcan las prácticas de DX INTERMEDIACION
          INDEPENDIENTE de la forma más precisa posible. Al inscribirse y/o
          navegar el sitio Web de DX INTERMEDIACION INDEPENDIENTE, el usuario
          y/o el visitante presta su consentimiento para que se utilice su
          información personal de acuerdo a las disposiciones que se describen a
          continuación.
        </p>
        <p>
          Este documento es parte integrante de los  . Mediante la aceptación de
          los Términos y Condiciones Generales en el momento de la inscripción
          el usuario acepta las disposiciones aquí contenidas.
        </p>
        <p>
          Medios para ejercer los derechos de acceso, rectificación, cancelación
          y oposición en relación con los Datos Personales
        </p>
        <p>
          Los usuarios tienen reconocidos y podrán ejercitar los derechos de
          acceder, rectificar, cancelar y actualizar sus Datos Personales,
          incluyendo su dirección de e-mail, así como a oponerse al tratamiento
          de la misma y a ser informado de las cesiones llevadas a cabo, todo
          ello de conformidad a lo dispuesto en la normativa aplicable. Los
          usuarios garantizan y responden, en cualquier caso, de la veracidad,
          exactitud, vigencia y autenticidad de los Datos Personales
          facilitados, y se comprometen a mantenerlos debidamente actualizados.
        </p>
        <p>
          Una vez inscrito en DX INTERMEDIACION INDEPENDIENTE, el usuario podrá
          revisar y cambiar la información que nos ha enviado durante el proceso
          de inscripción incluyendo:
        </p>
        <p>
          el Seudónimo y dirección de correo electrónico. Sin perjuicio de los
          cambios que realice, DX INTERMEDIACION INDEPENDIENTE conservará los
          Datos Personales anteriores por motivos de seguridad y control del
          fraude.
        </p>
        <p>
          la información de la inscripción como: compañía, domicilio, ciudad,
          región, código postal, número principal de teléfono, número secundario
          de teléfono, número de fax, correo electrónico, etc.
        </p>
        <p>la clave.</p>
        <p>
          En determinados casos, mantendremos en nuestros archivos los Datos
          Personales que nos hayas pedido que retiremos, y ello con la finalidad
          de resolver disputas o reclamaciones, detectar problemas o incidencias
          y solucionarlos, y dar cumplimiento a lo dispuesto en los Términos y
          Condiciones Generales por el período de tiempo que determine la
          normativa aplicable. En cualquier caso, los Datos Personales de un
          usuario no será inmediatamente retirada de nuestros archivos por
          motivos legales y técnicos, incluyendo sistemas de soportes de
          seguridad. Por tanto, no se debe esperar que todos los Datos
          Personales sean definitivamente borrados de nuestras bases de datos.
        </p>
        <p>
          Los usuarios deben actualizar sus Datos Personales periódicamente
          conforme vaya cambiando para que los otros usuarios puedan ubicarlos
          cuando realicen una operación. Para hacer cualquier modificación en la
          información que suministrada en el momento de la Inscripción, se debe
          ingresar en la sección.
        </p>
        <p>
          Para recibir mayor información sobre la confidencialidad de tus Datos
          Personales , así como para el caso que desees ejercer tus derechos de
          acceder, rectificar, cancelar u oponerte al tratamiento de tus Datos
          Personales, contáctanos por correo electrónico. Nuestro Responsable de
          Protección de Datos es el Sr. Daniel Cárdenas Peña, a quien podrás
          contactar por correo electrónico a contacto@ DX INTERMEDIACION
          INDEPENDIENTE.com.
        </p>
        <p>Los datos que recabamos</p>
        <p>
          Lo primero que se debe hacer para disfrutar de los servicios de DX
          INTERMEDIACION INDEPENDIENTE es inscribirse, suministrando ciertos
          datos personales ("Datos Personales") completos y exactos. Podremos
          solicitar, recabar y almacenar los siguientes Datos Personales: apodo
          o seudónimo para operar en el sitio de DX INTERMEDIACION
          INDEPENDIENTE, nombre, número de documento o identificación válida,
          información física de contacto (como número de teléfono domicilio,
          dirección de e-mail, etc.). DX INTERMEDIACION INDEPENDIENTE no
          recabará de sus usuarios datos personales sensibles tales como datos
          religiosos, sindicales, raciales, étnicos, etc. DX INTERMEDIACION
          INDEPENDIENTE podrá confirmar los Datos Personales suministrados
          acudiendo a entidades públicas, compañías especializadas o centrales
          de riesgo, para lo cual nos autorizas expresamente a compartir esos
          datos, incluyendo datos financieros y/o patrimoniales, con las
          mencionadas entidades. La información que DX INTERMEDIACION
          INDEPENDIENTE obtenga de estas entidades será tratada en forma
          confidencial.
        </p>
        <p>
          El Usuario que se registre en DX INTERMEDIACION INDEPENDIENTE a través
          de su cuenta personal en una red social ("Cuenta Personal"), o de
          cualquier modo acceda a DX INTERMEDIACION INDEPENDIENTE a través de su
          Cuenta Personal, consiente expresamente que DX INTERMEDIACION
          INDEPENDIENTE:
        </p>
        <p>
          Tenga acceso, en cualquier momento, a la totalidad de la información
          contenida en su Cuenta Personal, incluyendo en particular, pero sin
          limitación, a sus Datos Personales, información sobre sus intereses,
          gustos, contactos y cualquier otro contenido alojado en su Cuenta
          Personal;
        </p>
        <p>
          incluya en dicha cuenta, mensajes, fotografías, videos y cualquier
          otro tipo de contenido; y
        </p>
        <p>
          envíe al correo electrónico del Usuario vinculado a la Cuenta
          Personal, información o mensajes con la finalidad descripta en la
          sección "Finalidad del tratamiento de los Datos Personales" abajo.
        </p>
        <p>
          Se acuerda expresamente que en cualquier momento el usuario registrado
          en DX INTERMEDIACION INDEPENDIENTE podrá solicitar la baja o cierre de
          su solicitud de registración, y/o el cierre de su cuenta o eliminación
          de su cuenta e información de la base de datos de DX INTERMEDIACION
          INDEPENDIENTE. Por favor revisa la sección "Medios para ejercer los
          derechos de acceso, cancelación y rectificación de los Datos
          Personales" abajo.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE recoge y almacena automáticamente
          cierta información sobre la actividad de los usuarios y visitantes
          dentro de su sitio web. Tal información puede incluir la URL de la que
          provienen (estén o no en nuestro sitio web), a qué URL acceden
          seguidamente (estén o no en nuestro sitio web), qué navegador están
          usando, y sus direcciones IP. También las páginas visitadas, las
          búsquedas realizadas, las publicaciones, compras o ventas,
          calificaciones y réplicas ingresadas, mensajes en los foros, entre
          otra información podrá ser almacenada y retenida.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE accede a las listas de contactos de
          los dispositivos móviles utilizados por los usuarios para proveer sus
          servicios. Esa información la utilizará únicamente para localizar y
          señalar números de teléfonos celulares y/o correos electrónicos de
          otros usuarios. A su vez, los usuarios tienen autorización para
          compartir dicha información con DX INTERMEDIACION INDEPENDIENTE.
        </p>
        <p>
          En cuanto a los potenciales usuarios, DX INTERMEDIACION INDEPENDIENTE
          no almacenará nombres, direcciones postales, datos bancarios, números
          de cédula de identidad y/o documentos de identidad, ni ninguna otra
          información que permita identificar o haga identificable a una
          persona. Solo almacenará números de teléfonos celulares y correos
          electrónicos.
        </p>
        <p>
          Si los usuarios nos envían correspondencia sean correos electrónicos o
          cartas, o si otros usuarios o terceros nos envían correspondencia
          sobre las actividades o sobre los mensajes de otros usuarios en
          nuestro sitio, podemos recoger y almacenar tales Datos Personales,
          incluyendo direcciones de e-mail.
        </p>
        <p>Finalidad del tratamiento de los Datos Personales</p>
        <p>
          Para suministrar un excelente servicio y para que los usuarios puedan
          realizar operaciones en forma ágil y segura, DX INTERMEDIACION
          INDEPENDIENTE requiere cierta información de carácter personal,
          incluyendo dirección de e-mail. La recolección de información nos
          permite ofrecer a los usuarios servicios y funcionalidades que se
          adecuen mejor a sus necesidades y personalizar nuestros servicios para
          hacer que sus experiencias con DX INTERMEDIACION INDEPENDIENTE sean lo
          más cómodas posible. Los Datos Personales que recabamos se destinan a
          las siguientes finalidades:
        </p>
        <p>
          Ayudar al comprador y vendedor a entrar en contacto directo en la
          oportunidad que corresponda según la modalidad de la compra. En este
          caso, DX INTERMEDIACION INDEPENDIENTE suministrará a los interesados
          sus Datos Personales (nombre, teléfonos, localidad y correo
          electrónico), a través de correo electrónico o a través del sitio. La
          información así conocida por el comprador o el vendedor, sólo podrá
          ser utilizada a efectos de concluir la operación originada en DX
          INTERMEDIACION INDEPENDIENTE y no deberá ser empleada por ninguno de
          ellos con fines publicitarios o promocionales u otras actividades no
          relacionadas con DX INTERMEDIACION INDEPENDIENTE, salvo la expresa
          autorización del usuario.
        </p>
        <p>
          Desarrollar estudios internos sobre los intereses, comportamientos y
          demografía de los usuarios para comprender mejor sus necesidades e
          intereses y ofrecer mejores servicios o proveerles información
          relacionada.
        </p>
        <p>
          Mejorar nuestras iniciativas comerciales y promocionales y analizar
          las páginas visitadas las búsquedas realizadas por los usuarios, para
          mejorar nuestra oferta de contenidos y artículos, personalizar dichos
          contenidos, su presentación y servicios.
        </p>
        <p>
          Enviar información o mensajes por e-mail sobre nuevos servicios,
          mostrar publicidad o promociones, banners, de interés para nuestros
          usuarios, noticias sobre DX INTERMEDIACION INDEPENDIENTE, además de la
          información expresamente autorizada en la sección de preferencias. Si
          el usuario lo prefiere, puede solicitar que lo excluyan de las listas
          para el envío de información promocional o publicitaria. Por favor
          aprende a hacerlo la sección "Cambio de preferencias de e-mail" abajo.
        </p>
        <p>
          Enviar información o avisos por mensajes cortos de texto (SMS) al
          teléfono celular suministrado por el usuario a DX INTERMEDIACION
          INDEPENDIENTE. Los mensajes cortos de texto podrán contener avisos
          publicitarios y/o promocionales de DX INTERMEDIACION INDEPENDIENTE y/o
          terceros, así como información sobre los servicios de DX
          INTERMEDIACION INDEPENDIENTE, incluyendo en particular pero sin
          limitación, recordatorios de vencimientos de pagos y otras
          obligaciones adquiridas por el uso de los servicios prestados por DX
          INTERMEDIACION INDEPENDIENTE.
        </p>
        <p>
          Los ganadores de las Promociones y/o concursos realizados por DX
          INTERMEDIACION INDEPENDIENTE autorizan expresamente a difundir sus
          nombres, Datos Personales e imágenes y los de sus familias, por los
          medios y en las formas que consideren convenientes, con fines
          publicitarios y/o promocionales, sin derecho a compensación alguna.
        </p>
        <p>
          Compartir los Datos Personales (incluyendo dirección de e-mail e
          información patrimonial y/o financiera) con los proveedores de
          servicios o las empresas de "outsourcing" que contribuyan a mejorar o
          facilitar las operaciones a través de DX INTERMEDIACION INDEPENDIENTE,
          como (sin limitarse a) servicios de transporte, medios de pago,
          seguros o intermediarios en la gestión de pagos, call centers o
          programas de fidelidad, entidades públicas y/o privadas que brindan
          información crediticia, entre otros. DX INTERMEDIACION INDEPENDIENTE
          velará porque se cumplan ciertos estándares, mediante la firma de
          acuerdos o convenios cuyo objeto sea la privacidad de los Datos
          Personales de nuestros usuarios. No obstante, DX INTERMEDIACION
          INDEPENDIENTE no se hace responsable por el uso indebido de los Datos
          Personales del usuario que hagan estas compañías o sitios de Internet.
          En algunos casos, estos proveedores de servicios serán quienes recojan
          información directamente del usuario (por ejemplo si les solicitamos
          que realicen encuestas o estudios). En tales casos, podrá recibir una
          notificación acerca de la participación de un proveedor de servicios
          en tales actividades, y quedará a discreción del usuario toda la
          información que quiera brindarle y los usos adicionales que los
          proveedores decidan hacer. En caso de que facilites, por propia
          iniciativa información adicional a dichos prestadores de servicios
          directamente, tales Prestadores usarán esta información conforme a sus
          propias políticas de privacidad. Si decidimos revelar o compartir
          Datos Personales con terceros que no son proveedores de servicios o
          empresas afiliadas o relacionadas con DX INTERMEDIACION INDEPENDIENTE,
          requeriremos tu consentimiento. Entre los proveedores de servicios que
          recogen información directamente del usuario se encuentra Google Inc.,
          una compañía de Delaware cuya oficina principal está en 1600
          Amphitheatre Parkway, Mountain View (California), CA 94043, Estados
          Unidos ("Google"). Mediante el uso de "cookies" (ver apartado sobre
          "Cookies" más adelante), Google obtiene cierta información sobre la
          actividad de los usuarios de DX INTERMEDIACION INDEPENDIENTE y sus
          direcciones IP, que es directamente transmitida y archivada por Google
          en los servidores de Estados Unidos. Google usará esta información por
          cuenta de DX INTERMEDIACION INDEPENDIENTE con el propósito de analizar
          y confeccionar informes sobre la actividad de los usuarios en
          Internet, con miras a mejorar los servicios prestados por nuestro
          sitio web. Google podrá transmitir dicha información a terceros cuando
          así se lo requiera la normativa aplicable, o cuando dichos terceros
          procesen la información por cuenta de Google. El usuario consiente
          expresamente el tratamiento de su información por Google en la forma y
          para los fines aquí indicados.
        </p>
        <p>
          Suministrar los Datos Personales de los usuarios a las entidades que
          intervengan en la resolución de disputas entre los mismos, tales como:
          Compañías de Seguros, Amigables Componedores o Tribunales de Arbitraje
          o tribunales competentes para solucionar tales disputas.
        </p>
        <p>Confidencialidad de los Datos Personales</p>
        <p>
          Una vez inscrito en su sitio Web, DX INTERMEDIACION INDEPENDIENTE no
          venderá, alquilará o compartirá los Datos Personales excepto en las
          formas establecidas en este Aviso de Privacidad. Sin perjuicio de
          ello, el usuario consiente en forma expresa que DX INTERMEDIACION
          INDEPENDIENTE transfiera total o parcialmente los Datos Personales a
          cualquiera de las sociedades controladas, controlantes y/o vinculadas
          con DX INTERMEDIACION INDEPENDIENTE, a cualquier título y en el
          momento, forma y condiciones que estime pertinentes. Haremos todo lo
          que esté a nuestro alcance para proteger la privacidad de la
          información. Puede suceder que en virtud de órdenes judiciales, o de
          regulaciones legales, nos veamos compelidos a revelar información a
          las autoridades o terceras partes bajo ciertas circunstancias, o bien
          en casos que terceras partes puedan interceptar o acceder a cierta
          información o transmisiones de datos en cuyo caso DX INTERMEDIACION
          INDEPENDIENTE no responderá por la información que sea revelada.
        </p>
        <p>Seudónimo</p>
        <p>
          Para interactuar dentro del sitio, los usuarios deben utilizar un
          seudónimo que los identificará. Los usuarios no tendrán acceso a los
          Datos Personales de los otros usuarios, salvo en el caso de que hayan
          realizado con ellos alguna operación a través de nuestra plataforma,
          luego de la cual ambas partes recibirán la información de la otra.
        </p>
        <p>Clave Personal</p>
        <p>
          Para acceder a los servicios reservados únicamente para los usuarios
          debidamente inscritos los usuarios dispondrán de una clave personal.
          Con ella podrán comprar, vender, calificar, entre otras actividades.
          Los usuarios deben mantener esta clave bajo absoluta confidencialidad
          y, en ningún caso, deberán revelarla o compartirla con otras personas.
        </p>
        <p>
          El usuario será responsable de todos los actos que tengan lugar
          mediante el uso de su Seudónimo y Clave, lo que incluye hacerse cargo
          del pago de las tarifas que eventualmente se devenguen o por los
          perjuicios que puedan sufrir otros usuarios por tal motivo. Si por
          cualquier razón un usuario creyera que alguien puede conocer su clave,
          deberá modificarla ingresando desde el menú de navegación en.
        </p>
        <p>Menores de Edad</p>
        <p>
          Nuestros servicios sólo están disponibles para aquellas personas que
          tengan capacidad legal para contratar. Por lo tanto, aquellos que no
          cumplan con esta condición deberán abstenerse de suministrar Datos
          Personales para ser incluidos en nuestras bases de datos. Sin embargo,
          pueden hacerlo a través de los padres o tutores.
        </p>
        <p>El uso de los Datos Personales por otros Usuarios</p>
        <p>
          Para facilitar la interacción entre todos los miembros de la comunidad
          de DX INTERMEDIACION INDEPENDIENTE, nuestro servicio permite un acceso
          limitado a ciertos datos de contacto del resto de usuarios, tales como
          Nombre de usuario, Teléfonos, Ciudad y dirección de correo
          electrónico.
        </p>
        <p>
          Los usuarios sólo podrán utilizar los Datos Personales de otros
          usuarios obtenidos en el sitio para: (a) comunicaciones relacionadas
          con DX INTERMEDIACION INDEPENDIENTE que no constituyan comunicaciones
          comerciales no solicitadas, (b) utilizar servicios ofrecidos en DX
          INTERMEDIACION INDEPENDIENTE (por ejemplo: depósito, seguros, envío o
          transporte y reclamaciones sobre fraude), y (c) cualquier otra
          finalidad a la que el usuario correspondiente consienta expresamente
          una vez le hayan sido comunicadas previamente la información
          legalmente requerida.
        </p>
        <p>
          Bajo ninguna circunstancia, se debe comunicar Datos Personales o
          dirección de correo electrónico de otro usuario a ningún tercero sin
          nuestro consentimiento y el del usuario afectado. No se debe agregar a
          la agenda de direcciones de correo electrónico (física o electrónica)
          los datos de ningún usuario de DX INTERMEDIACION INDEPENDIENTE, ni
          siquiera los datos de quienes hayan adquirido algún artículo ofrecido
          en DX INTERMEDIACION INDEPENDIENTE, sin que medie el consentimiento
          expreso de tal usuario.
        </p>
        <p>Cookies</p>
        <p>
          El usuario y el visitante del sitio Web de DX INTERMEDIACION
          INDEPENDIENTE conoce y acepta que DX INTERMEDIACION INDEPENDIENTE
          podrá utilizar un sistema de seguimiento mediante la utilización de
          cookies (las "Cookies"). Las Cookies son pequeños archivos que se
          instalan en el disco rígido, con una duración limitada en el tiempo
          que ayudan a personalizar los servicios. También ofrecemos ciertas
          funcionalidades que sólo están disponibles mediante el empleo de
          Cookies. Las Cookies se utilizan con el fin de conocer los intereses,
          el comportamiento y la demografía de quienes visitan o son usuarios de
          nuestro Sitio Web y de esa forma, comprender mejor sus necesidades e
          intereses y darles un mejor servicio o proveerle información
          relacionada. También usaremos la información obtenida por intermedio
          de las Cookies para analizar las páginas navegadas por el visitante o
          usuario, las búsquedas realizadas, mejorar nuestras iniciativas
          comerciales y promocionales, mostrar publicidad o promociones, banners
          de interés, noticias sobre DX INTERMEDIACION INDEPENDIENTE ,
          perfeccionar nuestra oferta de contenidos y artículos, personalizar
          dichos contenidos, presentación y servicios; también podremos utilizar
          Cookies para promover y hacer cumplir las reglas y seguridad del
          sitio. DX INTERMEDIACION INDEPENDIENTE podrá agregar Cookies en los
          e-mails que envíe para medir la efectividad de las promociones.
        </p>
        <p>
          Utilizamos adicionalmente las Cookies para que el usuario no tenga que
          introducir su clave tan frecuentemente durante una sesión de
          navegación, también para contabilizar y corroborar las inscripciones,
          la actividad del usuario y otros conceptos para acuerdos comerciales,
          siempre teniendo como objetivo de la instalación de las Cookies, el
          beneficio del usuario que la recibe, y no será usado con otros fines
          ajenos a DX INTERMEDIACION INDEPENDIENTE.
        </p>
        <p>
          Se establece que la instalación, permanencia y existencia de las
          Cookies en el computador del usuario depende de su exclusiva voluntad
          y puede ser eliminada de su computador cuando el usuario así lo desee.
          Para saber cómo quitar las Cookies del sistema es necesario revisar la
          sección Ayuda (Help) del navegador.
        </p>
        <p>
          Adicionalmente, se pueden encontrar Cookies u otros sistemas similares
          instalados por terceros en ciertas páginas de nuestro sitio Web. Por
          ejemplo, al navegar por una página creada por un usuario, puede que
          exista una Cookie emplazada en tal página.
        </p>
        <p>
          Por último, DX INTERMEDIACION INDEPENDIENTE almacena cookies para
          poder ofrecer una experiencia más interactiva en el sitio, basada en
          las acciones del usuario. El usuario puede, en cualquier momento,
          eliminar las cookies almacenadas, configurar el navegador para que
          solicite aprobación antes de almacenar cookies o directamente evitar
          que se almacenen cookies.
        </p>
        <p>
          Este procedimiento se realiza de forma diferente en los distintos
          navegadores y es necesario realizarlo en cada navegador que se
          utilice. A continuación, ponemos a disposición los diferentes
          procedimientos para manejar esta configuración en los navegadores más
          utilizados:
        </p>
        <p>- Microsoft Windows Explorer: </p>
        <p>- Google Chrome: </p>
        <p>- Mozilla Firefox: </p>
        <p>- Apple Safari: </p>
        <p>
          Se aclara expresamente que este Aviso de Privacidad cubre la
          utilización de Cookies por este sitio y no la utilización de Cookies
          por parte de anunciantes. Nosotros no controlamos el uso de Cookies
          por terceros.
        </p>
        <p>Spam</p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE y sus usuarios no aceptan conductas
          consideradas "spamming", ya sea en opiniones, preguntas, respuestas
          y/o el envío no solicitado de correos electrónicos. Queda
          absolutamente prohibido el envío indiscriminado de mensajes de
          cualquier naturaleza entre los usuarios de DX INTERMEDIACION
          INDEPENDIENTE.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE podrá suspender o inhabilitar
          definitivamente a aquellos usuarios que violen esta política.
        </p>
        <p> </p>
        <p>Datos Personales en las categorías especiales</p>
        <p>
          Dentro de la categoría Autos, motos y otros vehículos e Inmuebles y
          Propiedades se permite la inclusión del teléfono del vendedor en la
          publicación. En la categoría Servicios el Vendedor deberá incluir en
          la publicación su dirección de correo electrónico y su teléfono, y
          será optativa la publicación de su domicilio y de la url de su Sitio
          Web.
        </p>
        <p>
          El Vendedor sólo podrá ingresar los datos mencionados, según
          corresponda, dentro del campo específico al momento de publicar el
          artículo. Sin embargo, en ningún caso deberá incluirlo en la
          descripción o en el título de su publicación, ni en ningún otro lugar
          fuera del campo específico.
        </p>
        <p>
          Tampoco podrá el Vendedor incluir ningún otro dato personal dentro o
          fuera del campo indicado.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE no se hace responsable del uso que el
          vendedor, el comprador, cualquier usuario u otra persona pudieran
          hacer de la información publicada.
        </p>
        <p>Orden de autoridades competentes - Requerimientos Legales</p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE coopera con las autoridades
          competentes y con otros terceros para garantizar el cumplimiento de
          las leyes, por ejemplo, en materia de protección de derechos de
          propiedad industrial e intelectual, prevención del fraude y otras
          materias.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE podrá revelar los Datos Personales de
          sus usuarios bajo requerimiento de la autoridades judiciales o
          gubernamentales competentes para efectos de investigaciones conducidas
          por ellas, aunque no exista una orden ni una citación ejecutiva o
          judicial, o por ejemplo (y sin limitación a este supuesto) cuando se
          trate de investigaciones de carácter penal o de fraude o las
          relacionadas con piratería informática o la violación de derechos de
          autor. En tales situaciones, DX INTERMEDIACION INDEPENDIENTE
          colaborará con las autoridades competentes con el fin de salvaguardar
          la integridad y la seguridad de la Comunidad y la de sus usuarios.
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE puede (y los usuarios lo autorizan
          expresamente) comunicar cualquier Dato Personal sobre sus usuarios con
          la finalidad de cumplir la normativa aplicable y cooperar con las
          autoridades competentes en la medida en que discrecionalmente lo
          entendamos necesario y adecuado en relación con cualquier
          investigación de un ilícito o un fraude, infracción de derechos de
          propiedad industrial o intelectual, u otra actividad que sea ilegal o
          que pueda exponer a DX INTERMEDIACION INDEPENDIENTE o a sus usuarios a
          cualquier responsabilidad legal. Además, podemos (y los usuarios lo
          autorizan expresamente) comunicar su nombre completo, seudónimo,
          domicilio, ciudad, región, código postal, país, número de teléfono,
          dirección de correo electrónico, etc. a los participantes en el
          Programa de Protección de Propiedad Intelectual de DX INTERMEDIACION
          INDEPENDIENTE en la forma que, a nuestra discreción, entendamos
          necesaria o adecuada en relación con la investigación del fraude,
          infracción de derechos de propiedad industrial o intelectual,
          piratería, o cualquier otra actividad ilegal. Este derecho será
          ejercido por DX INTERMEDIACION INDEPENDIENTE a efectos de cooperar con
          el cumplimiento y ejecución de la ley, independientemente que no
          exista una orden judicial o administrativa al efecto.
        </p>
        <p>
          Además, DX INTERMEDIACION INDEPENDIENTE se reserva el derecho (y nos
          autorizas expresamente a ello) de comunicar información sobre sus
          usuarios a otros usuarios, entidades o terceros cuando haya motivos
          suficientes para considerar que la actividad de un usuario sea
          sospechosa de intentar o cometer un delito o intentar perjudicar a
          otras personas. Este derecho será utilizado por DX INTERMEDIACION
          INDEPENDIENTE a su entera discreción cuando lo considere apropiado o
          necesario para mantener la integridad y la seguridad de la Comunidad y
          la de sus usuarios, para hacer cumplir los Términos y Condiciones
          Generales y demás políticas del sitio y a efectos de cooperar con la
          ejecución y cumplimiento de la ley. Este derecho será ejercido por DX
          INTERMEDIACION INDEPENDIENTE independientemente que no exista una
          orden judicial o administrativa al efecto.
        </p>
        <p>
          Seguridad y medios para evitar el uso o divulgación de los Datos
          Personales. Almacenamiento y transferencia de los Datos Personales
        </p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE está obligado a cumplir con toda la
          normativa aplicable en materia de medidas de seguridad aplicables a
          los Datos Personales. Adicionalmente, DX INTERMEDIACION INDEPENDIENTE
          usa los estándares de la industria entre materia de protección de la
          confidencialidad de sus Datos Personales, incluyendo, en otras
          medidas, cortafuegos ("firewalls") y Secure Socket Layers ("SSL"). DX
          INTERMEDIACION INDEPENDIENTE considera a los datos de sus usuarios
          como un activo que debe ser protegido de cualquier pérdida o acceso no
          autorizado. Empleamos diversas técnicas de seguridad para proteger
          tales datos de accesos no autorizados por usuarios de dentro o fuera
          de nuestra compañía. Sin embargo, es necesario tener muy en cuenta que
          la seguridad perfecta no existe en Internet.
        </p>
        <p>
          El usuario de DX INTERMEDIACION INDEPENDIENTE conoce y acepta
          expresamente que DX INTERMEDIACION INDEPENDIENTE, a su exclusivo
          criterio, recabe, almacene y monitoree el intercambio de mensajes y
          correos electrónicos entre sus usuarios, efectuado dentro de la
          comunidad de DX INTERMEDIACION INDEPENDIENTE, con el objetivo de
          contribuir a la seguridad de las relaciones y comunicaciones en la
          comunidad.
        </p>
        <p>
          Por ello, DX INTERMEDIACION INDEPENDIENTE no se hace responsable por
          interceptaciones ilegales o violación de sus sistemas o bases de datos
          por parte de personas no autorizadas. DX INTERMEDIACION INDEPENDIENTE,
          tampoco se hace responsable por la indebida utilización de la
          información obtenida por esos medios.
        </p>
        <p>
          Todos los Datos Personales de los usuarios serán almacenados en un
          fichero automatizado de datos personales. El fichero de Datos
          Personales de los usuarios de DX INTERMEDIACION INDEPENDIENTE reside
          en México. El usuario al inscribirse en DX INTERMEDIACION
          INDEPENDIENTE confirma que está informado de la residencia de este
          fichero y autoriza esta transferencia de sus datos.
        </p>
        <p>Cambio en las preferencias de e-mails</p>
        <p>
          Sin perjuicio que DX INTERMEDIACION INDEPENDIENTE quiere mantener a
          sus usuarios actualizados en todo momento sobre promociones,
          novedades, cambios, etc. los usuarios pueden seleccionar los e-mails e
          información promocional que gustarían recibir de DX INTERMEDIACION
          INDEPENDIENTE.
        </p>
        <p>
          Si no quieres recibir correos electrónicos, puede de-suscribirse,
          cambiando tus preferencias de e-mail siguiendo las instrucciones que
          proporcionamos en nuestras comunicaciones o bien accediendo a tu
          cuenta en la sección Mi DX INTERMEDIACION INDEPENDIENTE. En esa
          sección podrás seleccionar las preferencias para que sean tenidas en
          cuenta por DX INTERMEDIACION INDEPENDIENTE en las futuras
          comunicaciones o enviando tus preferencias por correo a la dirección
          postal indicada en este Aviso de Privacidad.
        </p>
        <p>Procedimiento para comunicar los cambios al Aviso de Privacidad</p>
        <p>
          DX INTERMEDIACION INDEPENDIENTE podrá modificar en cualquier momento
          los términos y condiciones de este Aviso de Privacidad y
          confidencialidad y/o las prácticas de envío de e-mails. Si decidimos
          introducir algún cambio material a nuestro Aviso de Privacidad, te
          notificaremos publicando una versión actualizada del Aviso de
          Privacidad en esta sección o mediante el envío de un e-mail o
          informándolo en la página principal u otras secciones del sitio para
          mantenerte actualizado de los cambios realizados.
        </p>
        <p>
          Si hacemos cambios materiales en la forma que tus Datos Personales son
          administrados te notificaremos por e-mail para que puedas tomar una
          decisión informada respecto si aceptas o no que tus Datos Personales
          sean utilizados de esa forma. Si no aceptas esos términos, en ese caso
          quedará disuelto el vínculo contractual y tus Datos Personales no
          serán usados de otra forma que la que fue informada al momento de
          recabarse.
        </p>
        <p></p>
        <p></p>
      </div>
    </CustomSection>
  );
};

export default Privacity;
